import { render, staticRenderFns } from "./TransferMoneyUserType.vue?vue&type=template&id=35a9c99c&scoped=true&"
import script from "./TransferMoneyUserType.vue?vue&type=script&lang=js&"
export * from "./TransferMoneyUserType.vue?vue&type=script&lang=js&"
import style0 from "./TransferMoneyUserType.vue?vue&type=style&index=0&id=35a9c99c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a9c99c",
  null
  
)

export default component.exports